<template>
    <DnFormField
        class="base-form-field"
    >
        <template
            v-for="name in Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
    </DnFormField>
</template>

<script setup>
import DnFormField from '@digitalnatives/form-field';
</script>

<style lang="less">
.base-form-field.dn-form-field {
    & + & {
        margin-top: var(--spacing-md);
    }
}
</style>
